export default {
  crop: 'CROPS_GETTERS_CROP',
  cropById: 'CROPS_GETTERS_CROP_BYID',
  multiLanguageCropById: 'CROPS_GETTERS_MULTI_LANGUAGE_CROP_BYID',
  crops: 'CROPS_GETTERS_CROPS',
  filter: 'CROPS_GETTERS_FILTER',
  filteredCrops: 'CROPS_GETTERS_FILTEREDCROPS',
  cropgroups: 'CROPS_GETTERS_CROPGROUPS'
}
